// angular
import { Component, OnInit } from '@angular/core';

// others
import { VerifyExportDownloadService } from './verify-export-download.service';
import { AppService } from '../app.service';
import { FormBuilder } from '@angular/forms';
import { BaseComponent } from '../shared/base.component';
import { AuthService } from '../core/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../shared/base.service';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { dragDisable } from 'd3';

@Component({
    selector: 'app-verify-export-download',
    templateUrl: './verify-export-download.component.html',
    styleUrls: ['verify-export-download.component.scss'],
    providers: [VerifyExportDownloadService]
})

export class VerifyExportDownloadComponent extends BaseComponent implements OnInit {

    constructor(public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public appService: AppService,
        public route: ActivatedRoute,
        public service: VerifyExportDownloadService,
        public translate: TranslateService,
        public fb: FormBuilder) 
    {
        super(authService, router, baseService, appService);
    }

    downloadSuccess = false;
    errorMessage = null;
    srURL = '';

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.service.verifyDownload(params['downloadId'], params['token'])
                                    .subscribe(data => {
                                        setTimeout(() => {
                                            saveAs(data['body'], params['fileName']);
                                            this.isLoading = false;
                                            this.downloadSuccess = true;
                                        }, 2000);
                                    },
                                    error => {
                                        this.errorMessage = 'This file is no longer avaiable';
                                        this.isLoading = false;
                                    });
        });
    }
}
